import { Language } from './language';

const de = {
    code: Language.de,

	// HOME PAGE
	
	t_description: '{age} Jahre altes Schlagzeugermädchen',
	t_close: 'Schließen',

	b_home: 'Startseite',
	b_about: 'Über mich',
	b_press: 'Drücken Sie',
	b_shows: 'Live-Auftritte',
	b_soultone: 'Soultone',
	b_collision: 'Collision',
	b_language: 'Deutsch',
	b_share: 'Aktie',
	b_scroll_to_top: 'Nach oben scrollen',
	b_click: 'Klicken',
	b_tap: 'Tippen',

	t_english: 'Englisch',
	t_spanish: 'Spanisch',
	t_portuguese: 'Portugiesisch',
	t_italian: 'Italienisch',
	t_french: 'Französisch',
	t_german: 'Deutsch',
	t_chinese: 'Chinesisch',

	// SHOWS PAGE

	ClassicMetal_title: 'Klassisches Metall',
	ClassicMetal_description: 'School of Rock Seattle',

	StAlsGrandDay2024_title: 'Aufführung am Großen Tag 2024',
	StAlsGrandDay2024_description: 'St. Alphonsus Parish School Seattle',

	BlackViolinConcert_title: 'Schwarzes Violinkonzert mit The World Your Orchestra',
	BlackViolinConcert_description: 'Das Paramount Theater',

	MexicanIndependenceDay2024_title: 'Feier zum mexikanischen Unabhängigkeitstag mit dem Ballard Civic Orchestra',
	MexicanIndependenceDay2024_description: 'Rathaus Seattle',

	BluesRock_title: 'Blues Rock',
	BluesRock_description: 'School of Rock Seattle',

	BallardSeaFoodFest2024_title: 'Ballard Seafood Fest 2024',
	BallardSeaFoodFest2024_description: 'Ballard Seafood Fest',

	Funk_title: 'Funk',
	Funk_description: 'School of Rock Seattle',

	Heart_title: 'Heart',
	Heart_description: 'School of Rock Seattle',

	ModernMetal_title: 'Moderner Metal',
	ModernMetal_description: 'School of Rock Seattle',

	SeasonPreviewWinter2023_title: 'Saisonvorschau Winter 2023',
	SeasonPreviewWinter2023_description: 'School of Rock Seattle',

	SmashingPumpkins_title: 'Smashing Pumpkins',
	SmashingPumpkins_description: 'School of Rock Seattle',

	Nirvana_title: 'Nirvana',
	Nirvana_description: 'School of Rock Seattle',

	HairMetal_title: 'Haarmetall',
	HairMetal_description: 'School of Rock Seattle',

	TalentShow2023_title: 'Talentshow 2023',
	TalentShow2023_description: 'Grundschule Seattle Salmon Bay',

	Deftones_title: 'Deftones',
	Deftones_description: 'School of Rock Seattle',

	SeasonPreviewSpring2023_title: 'Saisonvorschau Frühjahr 2023',
	SeasonPreviewSpring2023_description: 'School of Rock Seattle',

	Ramones_title: 'The Ramones',
	Ramones_description: 'School of Rock Seattle',

	Soundtrack_title: 'Soundtrack Show',
	Soundtrack_description: 'School of Rock Seattle',

	PopPunkVsEmo_title: 'Pop Punk Vs. Emo',
	PopPunkVsEmo_description: 'School of Rock Seattle',

	_90sNostalgia_title: 'Nostalgie der 90er Jahre',
	_90sNostalgia_description: 'School of Rock Seattle',

	TalentShow2022_title: 'Talentshow 2022',
	TalentShow2022_description: 'Grundschule Seattle Salmon Bay',
	
	// PRESS PAGE

	b_watch_here: 'Hier ansehen',

	fox_13_news_title: 'Fox 13 Seattle News mit',
	fox_13_news_description: 'Wahrer Nordwestabschnitt mit',

	the_daly_migs_show_interview_title: 'Interview mit der Daly Migs Show',
	the_daly_migs_show_interview_description: 'Interview über die Einladung zu Godsmack on Stage',

	alizee_defan_07_02_2024_title: '"Alizee Defan" interview',
	alizee_defan_07_02_2024_description: 'Eksklusivt interview',

	jaime_mendez_news_06_26_2024_title: '"Jaime Mendez Nieuws"-interview',
	jaime_mendez_news_06_26_2024_description: 'Lokaal Seattle-nieuws in het Spaans',

	bien_informado_03_22_2023_title: 'Artikel von "Bien Informado',
	bien_informado_03_22_2023_description: 'Artikel auf der argentinischen Nachrichtenseite über Victoria Drums',

	wave_potter_reaction_01_30_2023_title: 'Wave Potter Reaktion',
	wave_potter_reaction_01_30_2023_description: 'Wave Potter reagiert auf Victorias Cover von Lux Æterna von Metallica',

	// ABOUT PAGE

	b_back: 'Geh zurück',

	t_title: 'Victoria Acosta',
	t_pronouns: '(sie/ihr)',

	b_read_more: 'Mehr lesen',
	b_read_less: 'Weniger anzeigen',

	t_about: `
Mit Sticks in der Hand und Rhythmus im Blut begeistert die {age}-jährige Victoria Acosta als eine der spannendsten jungen Schlagzeugerinnen der heutigen Zeit.

Geboren in El Paso, Texas, und aufgewachsen in Guadalajara, Mexiko, lebt Victoria heute in Seattle, wo sie weiterhin mit ihrer außergewöhnlichen Hingabe zur Musik beeindruckt.

Ihre Liebe zum Schlagzeug begann im Alter von vier Jahren, und als sie am 13. September 2018 ihr erstes Drumkit bekam, war klar: Es gab kein Zurück mehr. Sie begann ihre musikalische Ausbildung an der Musicalerias Academy in Guadalajara und setzte ihr Studium später in Seattle fort – mit beeindruckendem Fortschritt. Nach einer herausragenden Probestunde an der School of Rock am 29. Mai 2022 übersprang sie das Anfängerprogramm komplett und wurde direkt ins Performers Program aufgenommen. Seitdem hat Victoria das Publikum in {shows} Live-Auftritten mit ihrer mitreißenden Energie und starken Bühnenpräsenz begeistert.

Victorias musikalische Reise geht weit über die Bühne hinaus. Sie hat Hunderte von Videos für soziale Medien aufgenommen und sich damit eine treue Fangemeinde aufgebaut. Am 13. Juni 2024 wurde sie als Gastschlagzeugerin vom italienischen Komponisten Alberto Rigonni für das Album Nemesis Call eingeladen. Im selben Jahr erhielt sie am 12. September ein Endorsement von Soultone Cymbals, und am 8. März 2025 wurde sie in das Künstlerprogramm von Collision Drumsticks aufgenommen – ein weiterer bedeutender Schritt in ihrer aufstrebenden Karriere.

Neben dem Schlagzeugspielen begann Victoria in der vierten Klasse mit dem Violinspiel. 2024 trat sie dem World Youth Orchestra bei, spielte gemeinsam mit dem Duo Black Violin im Paramount Theatre und gab später ihr Debüt als Perkussionistin mit dem Ballard Civic Orchestra im Town Hall Seattle bei einer Feier zum mexikanischen Unabhängigkeitstag.

Zu ihren Auszeichnungen zählen der Gold Prize und der Fantastic Technique Award beim London Young Musician Contest 2022, sowie der Annual Star Musician Award und der Outstanding Drummer Special Award im Jahr 2023.

Victoria übt täglich und überschreitet dabei ständig ihre eigenen Grenzen – sowohl als Schlagzeugerin als auch als Violinistin. Mit ihrem unaufhaltsamen Antrieb und ihrer grenzenlosen Kreativität ist sie nicht nur ein aufgehender Stern – sie ist eine Naturgewalt in der Entstehung.
	`,

	// PRESS PAGE

	t_footer: 'Alle Rechte vorbehalten',

		// SOULTONE: 

		b_visit_artist_page: 'Besuchen Sie meine Künstlerseite',

}

export default de;
